export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  description: string;
  coverImage: string;
  rating: number;
  views: number;
  status: string;
  updateDate: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const categories: { name: string; slug: string; description: string; icon: string }[] = [
  { name: '恋爱韩漫', slug: 'romance', description: '甜蜜浪漫的恋爱故事，心动瞬间尽在恋爱韩漫', icon: 'ri-heart-line' },
  { name: '奇幻韩漫', slug: 'fantasy', description: '穿越异世界，魔法与冒险的奇幻之旅', icon: 'ri-magic-line' },
  { name: '动作韩漫', slug: 'action', description: '热血激燃的战斗场面，肾上腺素飙升的动作韩漫', icon: 'ri-sword-line' },
  { name: '悬疑韩漫', slug: 'suspense', description: '扣人心弦的悬疑剧情，层层反转烧脑体验', icon: 'ri-search-eye-line' },
  { name: '搞笑韩漫', slug: 'comedy', description: '轻松愉快的搞笑日常，笑到停不下来', icon: 'ri-emotion-laugh-line' },
  { name: '剧情韩漫', slug: 'drama', description: '深刻动人的剧情故事，引人入胜的人生百态', icon: 'ri-book-open-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '她的逆袭',
    author: '金秀雅',
    category: '恋爱韩漫',
    categorySlug: 'romance',
    description: '平凡女孩林小夏在被青梅竹马背叛后，意外获得神秘系统，开启了一段华丽逆袭之路。她不再是那个任人欺负的丑小鸭，而是蜕变为让所有人惊艳的白天鹅。当曾经的青梅竹马回心转意，她该如何选择？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20romance%20cover%20art%2C%20beautiful%20young%20woman%20with%20long%20dark%20hair%20wearing%20elegant%20dress%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20clean%20simple%20background%20with%20floating%20rose%20petals%2C%20romantic%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20anime%20aesthetic%2C%20high%20quality%20rendering&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    views: 1280000,
    status: '连载中',
    updateDate: '2026-07-03',
    chapters: [
      { id: 1, title: '第1话 命运的转折', updateDate: '2026-06-20' },
      { id: 2, title: '第2话 神秘系统', updateDate: '2026-06-22' },
      { id: 3, title: '第3话 初次改变', updateDate: '2026-06-25' },
      { id: 4, title: '第4话 惊艳全场', updateDate: '2026-06-28' },
      { id: 5, title: '第5话 旧爱的后悔', updateDate: '2026-07-01' },
    ],
    tags: ['逆袭', '恋爱', '系统', '成长'],
  },
  {
    id: 2,
    title: '异世界剑圣',
    author: '李东旭',
    category: '奇幻韩漫',
    categorySlug: 'fantasy',
    description: '普通高中生韩宇在一次意外中穿越到剑与魔法的异世界。凭借现代人的思维和超强的剑术天赋，他从一介平民一步步成长为名震大陆的剑圣。然而黑暗势力正在苏醒，整个世界都陷入了危机之中。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20young%20male%20swordsman%20holding%20glowing%20sword%2C%20wearing%20fantasy%20armor%20with%20cape%2C%20magical%20blue%20energy%20effects%2C%20epic%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20clean%20simple%20background%20with%20subtle%20magic%20glow%2C%20high%20quality%20anime%20rendering&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 9.2,
    views: 980000,
    status: '连载中',
    updateDate: '2026-07-02',
    chapters: [
      { id: 1, title: '第1话 穿越异世界', updateDate: '2026-06-15' },
      { id: 2, title: '第2话 初遇伙伴', updateDate: '2026-06-18' },
      { id: 3, title: '第3话 剑术试炼', updateDate: '2026-06-22' },
      { id: 4, title: '第4话 黑暗来袭', updateDate: '2026-06-27' },
      { id: 5, title: '第5话 剑圣之名', updateDate: '2026-07-01' },
    ],
    tags: ['异世界', '剑术', '冒险', '魔法'],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴志勋',
    category: '悬疑韩漫',
    categorySlug: 'suspense',
    description: '首尔的夜晚，连环杀人案接连发生。前刑警姜赫被卷入一场跨越十年的阴谋之中。每一集都有令人意想不到的反转，每一个嫌疑人背后都隐藏着不为人知的秘密。真相到底是什么？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20dark%20noir%20style%2C%20man%20in%20trench%20coat%20standing%20in%20rainy%20night%20street%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20mysterious%20atmosphere%2C%20Korean%20digital%20illustration%2C%20film%20noir%20aesthetic%2C%20dramatic%20lighting%2C%20high%20contrast&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 9.7,
    views: 1560000,
    status: '连载中',
    updateDate: '2026-07-02',
    chapters: [
      { id: 1, title: '第1话 深夜来电', updateDate: '2026-06-10' },
      { id: 2, title: '第2话 第一具尸体', updateDate: '2026-06-14' },
      { id: 3, title: '第3话 嫌疑人的不在场证明', updateDate: '2026-06-18' },
      { id: 4, title: '第4话 十年前的真相', updateDate: '2026-06-23' },
      { id: 5, title: '第5话 谁是幕后黑手', updateDate: '2026-06-29' },
    ],
    tags: ['悬疑', '推理', '犯罪', '反转'],
  },
  {
    id: 4,
    title: '我的同桌是狐仙',
    author: '崔恩智',
    category: '恋爱韩漫',
    categorySlug: 'romance',
    description: '高中生李智恩某天发现自己的同桌竟然是一只修炼千年的九尾狐！为了不暴露身份，这位狐仙大人不得不过起了普通高中生的生活。然而人类世界的种种规则让这位狐仙大人闹出了不少笑话，一段奇妙的校园恋爱故事就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20cover%20art%2C%20cute%20high%20school%20girl%20with%20fox%20ears%20and%20tail%2C%20school%20uniform%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20spring%20color%20palette%2C%20Korean%20digital%20illustration%20style%2C%20clean%20simple%20background%2C%20sweet%20romantic%20vibe&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 9.4,
    views: 1100000,
    status: '连载中',
    updateDate: '2026-07-01',
    chapters: [
      { id: 1, title: '第1话 新来的转学生', updateDate: '2026-06-16' },
      { id: 2, title: '第2话 秘密被发现了', updateDate: '2026-06-20' },
      { id: 3, title: '第3话 狐仙的烦恼', updateDate: '2026-06-24' },
      { id: 4, title: '第4话 校园祭', updateDate: '2026-06-28' },
    ],
    tags: ['校园', '奇幻', '恋爱', '搞笑'],
  },
  {
    id: 5,
    title: '魔王大人想退休',
    author: '尹泰浩',
    category: '搞笑韩漫',
    categorySlug: 'comedy',
    description: '统治魔界三千年的魔王大人突然宣布要退休！他把王位传给了一个看起来最靠谱的部下，然后伪装成普通人来到了人间。本以为可以过上悠闲的退休生活，没想到人间比魔界还难混。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20powerful%20demon%20lord%20wearing%20casual%20hoodie%20holding%20grocery%20bags%2C%20funny%20contrast%20between%20menacing%20horns%20and%20everyday%20life%2C%20bright%20colorful%20style%2C%20Korean%20digital%20illustration%2C%20comic%20expressions%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 9.1,
    views: 890000,
    status: '连载中',
    updateDate: '2026-07-02',
    chapters: [
      { id: 1, title: '第1话 退休宣言', updateDate: '2026-06-12' },
      { id: 2, title: '第2话 人间初体验', updateDate: '2026-06-16' },
      { id: 3, title: '第3话 找工作好难', updateDate: '2026-06-21' },
      { id: 4, title: '第4话 邻居是勇者后代', updateDate: '2026-06-26' },
    ],
    tags: ['搞笑', '奇幻', '日常', '反差萌'],
  },
  {
    id: 6,
    title: '首尔夜行',
    author: '郑宇成',
    category: '动作韩漫',
    categorySlug: 'action',
    description: '白天是普通的快递员，夜晚则是地下格斗场的王者。姜都城过着双面人生，直到某天他送的一个包裹将他卷入了一场关乎整个首尔地下世界的风暴。拳拳到肉的格斗场面，燃到爆炸！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20muscular%20fighter%20with%20wrapped%20fists%20in%20fighting%20stance%2C%20urban%20night%20cityscape%20background%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%20style%2C%20intense%20dynamic%20pose%2C%20high%20contrast%20warm%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 9.3,
    views: 1350000,
    status: '连载中',
    updateDate: '2026-07-03',
    chapters: [
      { id: 1, title: '第1话 双面人生', updateDate: '2026-06-08' },
      { id: 2, title: '第2话 神秘包裹', updateDate: '2026-06-13' },
      { id: 3, title: '第3话 地下格斗场', updateDate: '2026-06-18' },
      { id: 4, title: '第4话 风暴将至', updateDate: '2026-06-24' },
      { id: 5, title: '第5话 真正的对手', updateDate: '2026-06-30' },
    ],
    tags: ['动作', '格斗', '都市', '热血'],
  },
  {
    id: 7,
    title: '重生之我是财阀',
    author: '金泰熙',
    category: '剧情韩漫',
    categorySlug: 'drama',
    description: '一位在底层挣扎了四十年的普通上班族意外回到二十年前，带着记忆重生的他决定利用先知优势，从股市到房地产，一步步打造自己的商业帝国。然而商场如战场，每一步都暗藏危机。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20business%20cover%20art%2C%20confident%20man%20in%20luxury%20suit%20standing%20in%20modern%20skyscraper%20office%2C%20Seoul%20cityscape%20through%20window%2C%20professional%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20clean%20polished%20look%2C%20warm%20golden%20lighting&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 9.6,
    views: 1420000,
    status: '连载中',
    updateDate: '2026-07-01',
    chapters: [
      { id: 1, title: '第1话 重生', updateDate: '2026-06-05' },
      { id: 2, title: '第2话 第一桶金', updateDate: '2026-06-10' },
      { id: 3, title: '第3话 地产之争', updateDate: '2026-06-15' },
      { id: 4, title: '第4话 商业联盟', updateDate: '2026-06-21' },
      { id: 5, title: '第5话 股价大战', updateDate: '2026-06-27' },
    ],
    tags: ['重生', '商战', '逆袭', '剧情'],
  },
  {
    id: 8,
    title: '月下契约',
    author: '李瑞妍',
    category: '奇幻韩漫',
    categorySlug: 'fantasy',
    description: '月圆之夜，少女苏琳与一位神秘男子签下了契约——用自己的寿命换取治愈妹妹绝症的能力。然而她不知道的是，这位神秘男子正是被封印千年的月神。一段跨越人神界限的凄美爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20cover%20art%2C%20mysterious%20woman%20under%20full%20moonlight%2C%20flowing%20silver%20hair%2C%20ethereal%20moonlight%20glow%2C%20ancient%20celestial%20aesthetic%2C%20Korean%20digital%20illustration%20style%2C%20mystical%20atmosphere%2C%20clean%20simple%20background%2C%20dreamy%20color%20palette&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 9.3,
    views: 1050000,
    status: '连载中',
    updateDate: '2026-07-02',
    chapters: [
      { id: 1, title: '第1话 满月之夜', updateDate: '2026-06-18' },
      { id: 2, title: '第2话 契约成立', updateDate: '2026-06-22' },
      { id: 3, title: '第3话 月神的秘密', updateDate: '2026-06-26' },
      { id: 4, title: '第4话 不可触碰的爱', updateDate: '2026-06-30' },
    ],
    tags: ['奇幻', '爱情', '契约', '月神'],
  },
  {
    id: 9,
    title: '猎魔人学院',
    author: '张贤宇',
    category: '动作韩漫',
    categorySlug: 'action',
    description: '隐藏在现代社会中的猎魔人学院，专门培养对抗恶魔的战士。新生李泰民天赋异禀却桀骜不驯，在一次次生死任务中逐渐成长为最优秀的猎魔人。但学院内部似乎隐藏着更大的阴谋。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%20art%2C%20young%20male%20demon%20hunter%20with%20silver%20hair%20holding%20magical%20weapon%2C%20modern%20school%20uniform%20with%20combat%20gear%2C%20dark%20energy%20effects%2C%20Korean%20digital%20illustration%2C%20dynamic%20action%20pose%2C%20high%20contrast&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    views: 760000,
    status: '连载中',
    updateDate: '2026-07-01',
    chapters: [
      { id: 1, title: '第1话 入学考试', updateDate: '2026-06-14' },
      { id: 2, title: '第2话 初次猎魔', updateDate: '2026-06-19' },
      { id: 3, title: '第3话 暗处的眼睛', updateDate: '2026-06-24' },
      { id: 4, title: '第4话 背叛者', updateDate: '2026-06-29' },
    ],
    tags: ['动作', '学院', '猎魔', '奇幻'],
  },
  {
    id: 10,
    title: '大小姐的秘密',
    author: '韩秀晶',
    category: '悬疑韩漫',
    categorySlug: 'suspense',
    description: '名门望族的大小姐宋雅琳表面上是完美无缺的社交名媛，实际上却是一个技艺高超的黑客。她利用自己的身份和技能暗中调查父亲离奇死亡的真相，却发现整个家族都隐藏着不可告人的秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20elegant%20woman%20in%20luxury%20evening%20dress%2C%20half%20face%20hidden%20in%20shadow%2C%20mysterious%20and%20sophisticated%20vibe%2C%20Korean%20digital%20illustration%20style%2C%20dark%20elegant%20color%20palette%2C%20film%20noir%20aesthetic%2C%20clean%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 9.4,
    views: 920000,
    status: '连载中',
    updateDate: '2026-07-03',
    chapters: [
      { id: 1, title: '第1话 完美名媛', updateDate: '2026-06-17' },
      { id: 2, title: '第2话 暗夜黑客', updateDate: '2026-06-21' },
      { id: 3, title: '第3话 父亲的秘密', updateDate: '2026-06-25' },
      { id: 4, title: '第4话 家族阴影', updateDate: '2026-06-30' },
    ],
    tags: ['悬疑', '豪门', '黑客', '复仇'],
  },
  {
    id: 11,
    title: '全职玩家',
    author: '吴志浩',
    category: '搞笑韩漫',
    categorySlug: 'comedy',
    description: '失业青年金道贤偶然进入了一款全息虚拟现实游戏，凭借超强的游戏天赋成为了全职职业玩家。在游戏里他是叱咤风云的顶级大神，在现实中却是一个连房租都交不起的废柴。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20gaming%20cover%20art%2C%20young%20man%20wearing%20VR%20headset%20with%20game%20controller%2C%20colorful%20game%20UI%20elements%2C%20messy%20room%20background%2C%20bright%20energetic%20color%20palette%2C%20Korean%20digital%20illustration%20style%2C%20fun%20dynamic%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 8.9,
    views: 670000,
    status: '连载中',
    updateDate: '2026-07-02',
    chapters: [
      { id: 1, title: '第1话 游戏开始', updateDate: '2026-06-11' },
      { id: 2, title: '第2话 隐藏职业', updateDate: '2026-06-16' },
      { id: 3, title: '第3话 第一桶游戏币', updateDate: '2026-06-21' },
      { id: 4, title: '第4话 公会之战', updateDate: '2026-06-26' },
    ],
    tags: ['游戏', '搞笑', 'VR', '逆袭'],
  },
  {
    id: 12,
    title: '消失的她',
    author: '申惠善',
    category: '悬疑韩漫',
    categorySlug: 'suspense',
    description: '结婚五年的妻子在某天早上突然消失，没有留下任何痕迹。丈夫郑浩俊在寻找妻子的过程中，逐渐发现了一个令人毛骨悚然的真相——他可能根本不了解自己的妻子。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20cover%20art%2C%20woman%20silhouette%20fading%20into%20darkness%2C%20man%20reaching%20out%20desperately%2C%20ominous%20atmosphere%2C%20Korean%20digital%20illustration%20style%2C%20dark%20moody%20color%20palette%2C%20psychological%20tension%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 9.8,
    views: 1680000,
    status: '已完结',
    updateDate: '2026-06-30',
    chapters: [
      { id: 1, title: '第1话 消失的早晨', updateDate: '2026-05-01' },
      { id: 2, title: '第2话 陌生的她', updateDate: '2026-05-08' },
      { id: 3, title: '第3话 双重身份', updateDate: '2026-05-15' },
      { id: 4, title: '第4话 真相浮现', updateDate: '2026-05-22' },
      { id: 5, title: '第5话 最后的信', updateDate: '2026-06-01' },
      { id: 6, title: '第6话 终章 重逢', updateDate: '2026-06-15' },
    ],
    tags: ['悬疑', '婚姻', '消失', '反转'],
  },
];